import _objectSpread from "/var/www/costaatlanticamtbtour.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/var/www/costaatlanticamtbtour.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from "react";
import { clsx, cssClass } from "../utils.js";
import { useController } from "../modules/Controller.js";
import { ELEMENT_BUTTON, ELEMENT_ICON } from "../consts.js";
export var IconButton = React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      className = _ref.className,
      Icon = _ref.icon,
      renderIcon = _ref.renderIcon,
      onClick = _ref.onClick,
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, ["label", "className", "icon", "renderIcon", "onClick", "style"]);

  var _useController$getLig = useController().getLightboxProps(),
      styles = _useController$getLig.styles;

  return React.createElement("button", _objectSpread({
    ref: ref,
    type: "button",
    "aria-label": label,
    className: clsx(cssClass(ELEMENT_BUTTON), className),
    onClick: onClick,
    style: _objectSpread({}, style, styles.button)
  }, rest), renderIcon ? renderIcon() : React.createElement(Icon, {
    className: cssClass(ELEMENT_ICON),
    style: styles.icon
  }));
});
IconButton.displayName = "IconButton";